import React from 'react';
import { mergeStyles, COMMON_STYLES } from '../../../constants';

export const Button = ({
  variant = 'secondary',
  onClick,
  disabled,
  children,
  style = {},
  ...props
}) => (
  <button
    className="clickable"
    onClick={onClick}
    disabled={disabled}
    style={mergeStyles(COMMON_STYLES.button.base, COMMON_STYLES.button[variant], style)}
    {...props}
  >
    {children}
  </button>
);
